import { IonButton, IonImg } from "@ionic/react";
import { StyleReactProps } from "@ionic/react/dist/types/components/react-component-lib/interfaces";

import "./Logo.css";

type IonImgProps = Omit<
  React.ForwardRefExoticComponent<
    Omit<React.HTMLAttributes<HTMLIonImgElement>, "style"> &
      React.RefAttributes<HTMLIonImgElement> &
      StyleReactProps
  >,
  "src" | "$$typeof"
>;

function PageLogo(
  props: IonImgProps & {
    classNameFixed?: "logo-big" | "logo-grow" | "logo-nav";
  }
) {
  const { classNameFixed, ...imgProps } = props;

  return (
    <IonButton routerLink="/" fill="clear" className="ion-no-padding">
      <IonImg
        src="/mFP_icon.png"
        className={classNameFixed ? classNameFixed : "logo-grow"}
        alt="Logo"
        {...imgProps}
      />
    </IonButton>
  );
}

export { PageLogo };
